import { DatePipe, AsyncPipe, NgClass, TitleCasePipe } from '@angular/common';
import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  input,
  output,
  inject,
} from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';

import {
  AppointmentService,
  AppointmentTypesService,
  TimeconversionService,
  ToastMessageService,
} from '@fitness-force/api';
import { AppErrors } from '@fitness-force/models';
import { ErrorMsgComponent } from '@fitness-force/errors';
import type {
  AppointmentBookingResponse,
  AppointmentType,
  AppointmentTypeById,
  CreateAppointmentRequest,
  CreateRecurringAppointmentRequest,
  Membership,
  RepeatRuleResponse,
  TENANTSINTERFACE,
  UpdateAppointmentMembership,
  UpdateMembership,
} from '@fitness-force/models';
import { RruleComponent } from '../../../rrule/rrule.component';
import { ErrorsComponent } from '@fitness-force/errors';
import { AssignedToComponent } from '@fitness-force/common/assigned-to';
import { Store } from '@ngrx/store';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import {
  COMPANY_INFO,
  STAFF_STATE,
  APPOINTMENT_TYPE_STATE,
  TENANTS_INFO,
} from '@fitness-force/state';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { DatePickerModule } from 'primeng/datepicker';
import { DialogModule } from 'primeng/dialog';
import { DividerModule } from 'primeng/divider';
import { SelectModule } from 'primeng/select';
import { InputTextModule } from 'primeng/inputtext';
import { StyleClassModule } from 'primeng/styleclass';
import { BehaviorSubject, Observable, distinctUntilChanged } from 'rxjs';
import { MiniSearchComponent, MiniSearchV2Component } from '@fitness-force/common/search';
import { environment } from '@fitness-force/environments';
import { Ienum, StaffStatus } from '@fitness-force/enum';
import { Router } from '@angular/router';
import { ShortNamePipe } from '@fitness-force/pipes/short-name';
import { DrawerModule } from 'primeng/drawer';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { SelectRoomComponent } from '../../../select-room/select-room.component';
import {
  CheckRecurringAvailability,
  StaffAvailableResponse,
} from '@fitness-force/staff-availability-lib';
import { StaffAvailabilityService } from '@fitness-force/staff-availability-lib';
import { StaffAppointmentTypeLinkService } from '@fitness-force/staff-availability-lib';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import {
  StaffAppointmentTytpeLink,
  StaffAppointmentTytpeLinkResponse,
} from '@fitness-force/staff-availability-lib';
import { ConfirmationService } from 'primeng/api';
import { MessageModule } from 'primeng/message';
import { ToastModule } from 'primeng/toast';
import { SkeletonModule } from 'primeng/skeleton';
import { ProspectFormComponent } from '@fitness-force/prospect-form-lib';

@Component({
  selector: 'book-appointment',
  templateUrl: './book-appointment.component.html',
  styleUrls: ['./book-appointment.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ToastMessageService],
  standalone: true,
  imports: [
    DialogModule,
    InputTextModule,
    ButtonModule,
    DatePickerModule,
    SelectModule,
    FormsModule,
    DividerModule,
    AvatarModule,
    StyleClassModule,
    FormsModule,
    ReactiveFormsModule,
    RruleComponent,
    MiniSearchComponent,
    MiniSearchV2Component,
    AssignedToComponent,
    ErrorsComponent,
    ErrorMsgComponent,
    ShortNamePipe,
    DrawerModule,
    SelectRoomComponent,
    ToggleSwitchModule,
    ConfirmPopupModule,
    TranslateModule,
    MessageModule,
    ToastModule,
    SkeletonModule,
    ProspectFormComponent,
    AsyncPipe,
    NgClass,
    TitleCasePipe,
  ],
})
export class BookAppointmentComponent implements OnInit {
  private readonly store = inject(Store);
  readonly translate = inject(TranslateService);
  private readonly fb = inject(UntypedFormBuilder);
  private readonly apptTypeService = inject(AppointmentTypesService);
  private readonly timeConversionService = inject(TimeconversionService);
  datePipe = inject(DatePipe);
  readonly miniSearchV2Enabled = environment.miniSearchV2;
  private readonly appointmentService = inject(AppointmentService);
  private readonly toastMessageService = inject(ToastMessageService);
  private readonly router = inject(Router);
  private readonly staffAvailabilityService = inject(StaffAvailabilityService);
  private readonly confirmationService = inject(ConfirmationService);
  private readonly cd = inject(ChangeDetectorRef);
  private readonly staffAppointmentTypeLinkService = inject(
    StaffAppointmentTypeLinkService,
  );

  readonly showBookAppointment = input<boolean>(false, { alias: 'visible' });
  readonly tenantId = input<number>(0);
  readonly startDateTime = input<string>();
  readonly hideBookAppointment = output<boolean>({
    alias: 'CloseBookAppointment',
  });
  readonly appointmentEvent = output<any>({ alias: 'appointmentEvent' });
  readonly reloadData = output<any>({ alias: 'reloadData' });
  readonly clientId = input<number>(0);

  CreateAppointmentForm: UntypedFormGroup = new UntypedFormGroup({});
  apptTypeToShow: number = 5;
  selectedApptType: AppointmentType;
  selectedApptSubType: Observable<any> | any;
  isVirtal: boolean = false;
  showRRule: boolean = false;
  RRuleObject = <RepeatRuleResponse>{};
  selectedclient: any;
  showApptSubType = new BehaviorSubject(false);
  selectedRoom: { name: string } | any;
  selectedTrainer:
    | { name: string; availability: string; ff_picture: string }
    | undefined;
  getAccessedStaffList$: Observable<any> | any;
  appointmentTypeList$ = new BehaviorSubject<any[]>([]);
  appointmentSubTypeList$ = new BehaviorSubject<any[]>([]);
  roomList$ = new BehaviorSubject<any[]>([]);

  staffAppointmentTypeLinks = [] as StaffAppointmentTytpeLink[];

  errorDataModal = [] as any;
  errorMessages = [] as any;
  showErrorPopup$ = new BehaviorSubject(false);
  minimumDate: Date;
  minimumTime: any;

  currentTenant: Observable<any> | any;
  disableSaveBtn: boolean = false;
  error = new BehaviorSubject(null as AppErrors | null);
  filterStaffIds = new BehaviorSubject<number[]>([0]);

  clientMemberships: Membership[];
  selectedMembership: Membership;
  appointmentCreateResponse: AppointmentBookingResponse;
  chooseSubscriptionModal: boolean = false;
  showCreateProspectPopup$: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);

  staffAppointmentAvailability: any = new Map();
  isStaffAvailable: boolean = true;
  showSkeleton: boolean = false;

  allStaffs: [] = [];

  constructor() {
    this.minimumTime = new Date();
    this.minimumDate = new Date(new Date().setHours(0, 0, 0, 0));
  }

  ngOnInit(): void {
    this.componentInit();
  }

  componentInit() {
    this.store.select(COMPANY_INFO).subscribe((responseData) => {
      this.translate.setDefaultLang(responseData?.selectedLang?.LANG_CODE);
      this.translate.use(responseData?.selectedLang?.LANG_CODE);
    });

    this.store.select(TENANTS_INFO).subscribe((tenant: TENANTSINTERFACE) => {
      this.currentTenant = tenant.selected_tenant;
    });

    this.CreateAppointmentForm = this.fb.group({
      selectedApptType: [this.selectedApptType, [Validators.required]],
      selectedApptSubType: [this.selectedApptSubType, [Validators.required]],
      client_id: ['', [Validators.required]],
      startDate: [this.startDateTime(), [Validators.required]],
      selectedTrainer: ['', [Validators.required]],
      selectedRoom: [''],
      virtualUrl: [''],
      comments: [''],
      //accepts_trial:[false]
    });

    this.GetAppointmentTypes();
    this.GetStaffs();

    this.SelectedAssignedFormControl.valueChanges
      .pipe(distinctUntilChanged())
      .subscribe((trainer: any) => {
        if (trainer) {
          this.checkStaffAvailability();
        }
      });

    this.SelectedApptTypeFormControl.valueChanges
      .pipe(distinctUntilChanged())
      .subscribe((apptType: any) => {
        if (apptType) {
          this.GetStaffAppointmentLink(apptType.id);
          this.checkStaffAvailability();
        }
      });
  }

  GetAppointmentTypes() {
    this.store
      .select(APPOINTMENT_TYPE_STATE)
      .subscribe((responseData: AppointmentType[]) => {
        this.appointmentTypeList$.next(
          responseData.filter((appt) => appt.status.toLowerCase() == 'active'),
        );
        if (this.appointmentTypeList$.value.length > 0) {
          this.selectedApptType = this.appointmentTypeList$.value[0];
          this.SelectedApptTypeFormControl.setValue(this.selectedApptType);
          if (this.selectedApptType.is_room_mandatory) {
            this.SelectedRoomFormControl.setValidators(Validators.required);
            this.SelectedRoomFormControl.updateValueAndValidity();
          } else {
            this.SelectedRoomFormControl.setValidators(null);
            this.SelectedRoomFormControl.updateValueAndValidity();
          }
          this.GetAppointmentSubTypes(this.appointmentTypeList$.value[0].id);
          this.GetStaffAppointmentLink(this.appointmentTypeList$.value[0].id);
        }
      });
  }

  GetStaffAppointmentLink(appointmentTypeId: number) {
    this.staffAppointmentTypeLinkService
      .GetStaffAppointmentLinkByCategoryId(this.tenantId(), appointmentTypeId)
      .subscribe((response: StaffAppointmentTytpeLinkResponse) => {
        this.staffAppointmentTypeLinks = response.items ? response.items : [];
        if (this.staffAppointmentTypeLinks.length > 0) {
          const validStaff: number[] = [];
          const staffs = this.allStaffs.filter((staff: any) =>
            this.staffAppointmentTypeLinks.find(
              (link) => staff.id == link.staff_id,
            ),
          );
          this.getAccessedStaffList$ = staffs.filter((staff: any) => {
            const oStaffStatus = this.OStaffStatus.find(
              (o: any) => o.value == staff.status || o.key == staff.status,
            );
            if (
              oStaffStatus!.value == StaffStatus.Active ||
              oStaffStatus!.key == StaffStatus.Active
            ) {
              if (
                staff.role.toLowerCase() == 'admin' ||
                staff.role.toLowerCase() == 'staff'
              ) {
                validStaff.push(staff.id);
                return staff;
              }
            }
          });
          this.filterStaffIds.next(validStaff);
          this.cd.detectChanges();
        }
      });
  }

  GetAppointmentSubTypes(appointmentTypeId: number) {
    this.apptTypeService
      .getSingleAppointmentType(this.tenantId(), appointmentTypeId)
      .subscribe({
        next: (response: AppointmentTypeById) => {
          this.appointmentSubTypeList$.next(response.subtypes);
          if (response.subtypes) {
            this.selectedApptSubType = response.subtypes[0];
            this.SelectedApptSubTypeFormControl.setValue(
              this.selectedApptSubType,
            );
            this.showApptSubType.next(true);
          } else {
            this.selectedApptSubType = null;
            this.showApptSubType.next(false);
          }
        },
        error: () => {
          this.selectedApptSubType = null;
          this.showApptSubType.next(false);
        },
      });
  }

  GetStaffs() {
    this.store.select(STAFF_STATE).subscribe((data: any) => {
      if (data && data.staffList && data.staffList.length > 0) {
        this.allStaffs = data.staffList;
        const validStaff: number[] = [];
        let staffs = data.staffList;
        if (this.staffAppointmentTypeLinks.length > 0) {
          staffs = this.allStaffs.filter((staff: any) =>
            this.staffAppointmentTypeLinks.find(
              (link) => staff.id == link.staff_id,
            ),
          );
        }
        this.getAccessedStaffList$ = staffs.filter((staff: any) => {
          const oStaffStatus = this.OStaffStatus.find(
            (o: any) => o.value == staff.status || o.key == staff.status,
          );
          if (
            oStaffStatus!.value == StaffStatus.Active ||
            oStaffStatus!.key == StaffStatus.Active
          ) {
            if (
              staff.role.toLowerCase() == 'admin' ||
              staff.role.toLowerCase() == 'staff'
            ) {
              validStaff.push(staff.id);
              return staff;
            }
          }
        });
        this.filterStaffIds.next(validStaff);
      }
    });
  }

  SelectAppointmentType(apptType: any) {
    this.selectedApptType = apptType.value;
    this.SelectedApptTypeFormControl.setValue(this.selectedApptType);
    if (this.selectedApptType.is_room_mandatory) {
      this.SelectedRoomFormControl.setValidators(Validators.required);
      this.SelectedRoomFormControl.updateValueAndValidity();
    } else {
      this.SelectedRoomFormControl.setValidators(null);
      this.SelectedRoomFormControl.updateValueAndValidity();
    }
    //this.GetAcceptsTrialFormControl.setValue(this.selectedApptType.allows_trial);
    this.GetAppointmentSubTypes(apptType.value.id);
  }

  SelectAppointmentSubType(apptSubType: any) {
    if (apptSubType.value) this.selectedApptSubType = apptSubType.value;
    else this.selectedApptSubType = apptSubType;
    this.SelectedApptSubTypeFormControl.setValue(this.selectedApptSubType);
  }

  getSelectedColor(apptType: any) {
    return `border-${apptType.color}-400 bg-${apptType.color}-50 text-${apptType.color}-400 font-bold`;
  }

  SetIsVirtual(isVirtual: boolean) {
    this.isVirtal = isVirtual;
    if (isVirtual) {
      this.SelectedRoomFormControl.setValidators(null);
      this.SelectedRoomFormControl.setValue(null);
    } else {
      this.SelectedRoomFormControl.setValidators(
        this.selectedApptType.is_room_mandatory ? Validators.required : null,
      );
      this.VirtualUrlFormControl.setValidators(null);
      this.VirtualUrlFormControl.setValue(null);
    }

    this.SelectedRoomFormControl.updateValueAndValidity();
    this.VirtualUrlFormControl.updateValueAndValidity();
  }

  HideRRule(e: any): void {
    this.showRRule = e;
  }

  FetchRRuleData(e: any): void {
    this.RRuleObject.RRule = e.RRule;
    this.RRuleObject.RRuleText = e.RRuleText;
    this.checkStaffAvailability();
  }

  setClient(e: any) {
    if (e && e.clt_id > 0) {
      this.selectedclient = e;
      this.SelectedClientFormControl.setValue(e.clt_id);
    } else {
      this.selectedclient = null;
      this.SelectedClientFormControl.setValue(null);
    }
    this.SelectedClientFormControl.updateValueAndValidity();
  }

  confirm(event: Event) {
    if (this.CreateAppointmentForm.valid) {
      let translation: any;
      this.translate
        .get([
          'STAFF_SCHEDULE.MSG.WANT_BOOKING_PROCEES',
          'common.BUTTONS.BUTTON-TEXT-YES',
          'common.BUTTONS.BUTTON-TEXT-NO',
        ])
        .subscribe((translations) => {
          translation = translations;
        });
      this.confirmationService.confirm({
        target: event.target as EventTarget,
        key: 'bookconfirm',
        message: translation['STAFF_SCHEDULE.MSG.WANT_BOOKING_PROCEES'],
        icon: 'fa fa-exclamation-triangle',
        acceptLabel: translation['common.BUTTONS.BUTTON-TEXT-YES'],
        rejectLabel: translation['common.BUTTONS.BUTTON-TEXT-NO'],
        accept: () => {
          this.CreateAppointment(this.CreateAppointmentForm);
        },
      });
    } else {
      Object.keys(this.CreateAppointmentForm.controls).forEach((field) => {
        const control = this.CreateAppointmentForm.get(field);
        control?.markAsTouched({ onlySelf: true });
      });
    }
  }

  CreateAppointment(form: UntypedFormGroup) {
    if (this.CreateAppointmentForm.valid) {
      this.disableSaveBtn = true;
      const createAppointment: CreateAppointmentRequest =
        {} as CreateAppointmentRequest;
      let createRecurringAppointment: CreateRecurringAppointmentRequest =
        {} as CreateRecurringAppointmentRequest;
      createAppointment.appointment_type_id = this.selectedApptType.id;
      createAppointment.client_id = form.value.client_id;
      createAppointment.coach_id = form.value.selectedTrainer.id;
      createAppointment.comments = form.value.comments;
      createAppointment.is_virtual = this.isVirtal;
      createAppointment.virtual_url = form.value.virtualUrl;
      // createAppointment.accepts_trial = form.value.accepts_trial;
      createAppointment.room_id = form.value.selectedRoom
        ? form.value.selectedRoom.id
        : 0;
      createAppointment.start_date_time =
        this.timeConversionService.ConvertLocalDateTimeToUTC(
          form.value.startDate,
        );
      createAppointment.subtype_id = this.selectedApptSubType
        ? this.selectedApptSubType.id
        : 0;
      createRecurringAppointment = createAppointment;

      if (this.RRuleObject.RRule) {
        createRecurringAppointment.recurring_rule = this.RRuleObject.RRule;
        createRecurringAppointment.recurring_start_date =
          createAppointment.start_date_time;
        createRecurringAppointment.start_time =
          this.timeConversionService.GetUTCTimeFromDate(form.value.startDate);

        this.appointmentService
          .CreateRecurringAppointment(
            this.tenantId(),
            createRecurringAppointment,
          )
          .subscribe({
            next: async (response: AppointmentBookingResponse) => {
              this.translate
                .get('SCHEDULE.MSG.CREATE_RECURRING_APPT_MSG')
                .subscribe((translation) => {
                  this.toastMessageService.showSuccess(translation);
                });
              if (
                response &&
                response.create_response &&
                response.create_response.info &&
                response.create_response.info.length > 0
              ) {
                response.create_response.info.forEach((info: any) => {
                  this.translate
                    .get('SCHEDULE.MSG.OVERLAP_MESSAGE', {
                      type: info.jsonObject.identifier,
                      startDate: this.datePipe.transform(
                        this.timeConversionService.ConvertUTCToLocalDateTime(
                          info.jsonObject.startDateTime,
                        ),
                        'MMM d, y, h:mm:ss a',
                      ),
                      endDate: this.datePipe.transform(
                        this.timeConversionService.ConvertUTCToLocalDateTime(
                          info.jsonObject.endDateTime,
                        ),
                        'MMM d, y, h:mm:ss a',
                      ),
                    })
                    .subscribe((translation) => {
                      this.toastMessageService.showWarning(translation);
                    });
                });
              }
              this.reloadData.emit(true);
              await this.timeout(1000);
              this.hideBookAppointment.emit(false);

              // # discussion pending on recurring appointment create have change membership option or not
              //  if(response.client_booked_details[0].memberships)
              //  {
              //     this.clientMemberships = response.client_booked_details[0].memberships;
              //     this.selectedMembership = response.client_booked_details[0].memberships.find(m => m.is_selected == true)!;
              //     this.chooseSubscriptionModal = true;
              //  }
              //  else {
              //     this.reloadData.emit(true);
              //     await this.timeout(1000);
              //     this.hideBookAppointment.emit(false);
              //}
            },
            error: (error) => {
              this.disableSaveBtn = false;
              this.handleError(error);
            },
          });
      } else {
        this.appointmentService
          .CreateAppointment(this.tenantId(), createAppointment)
          .subscribe({
            next: async (response: AppointmentBookingResponse) => {
              this.appointmentCreateResponse = response;
              if (response.client_booked_details[0].memberships) {
                this.clientMemberships =
                  response.client_booked_details[0].memberships;
                this.selectedMembership =
                  response.client_booked_details[0].memberships.find(
                    (m) => m.is_selected == true,
                  )!;
                if (this.clientMemberships.length > 1) {
                  this.chooseSubscriptionModal = true;
                  this.cd.detectChanges();
                } else {
                  this.chooseSubscriptionModal = false;
                  this.showResponseMessage(response);
                  this.reloadData.emit(true);
                  await this.timeout(1000);
                  this.hideBookAppointment.emit(false);
                  this.ClosePopup();
                  this.cd.detectChanges();
                }
              } else {
                this.closeBookingPopup();
              }
              this.cd.detectChanges();
            },
            error: (error: AppErrors) => {
              this.disableSaveBtn = false;
              this.ShowToastErrors(error);
              this.cd.detectChanges();
            },
          });
      }
    } else {
      Object.keys(this.CreateAppointmentForm.controls).forEach((field) => {
        const control = this.CreateAppointmentForm.get(field);
        control?.markAsTouched({ onlySelf: true });
      });
    }
  }

  async closeBookingPopup() {
    this.chooseSubscriptionModal = false;
    this.showResponseMessage(this.appointmentCreateResponse);
    await this.timeout(1000);
    this.reloadData.emit(true);
    this.hideBookAppointment.emit(false);
    this.ClosePopup();
  }

  showResponseMessage(response: any) {
    this.translate
      .get('SCHEDULE.MSG.CREATE_APPT_MSG')
      .subscribe((translation) => {
        this.toastMessageService.showSuccess(translation);
      });

    if (response.create_response.info && response.create_response.info[0]) {
      const info = response.create_response.info[0];
      this.translate
        .get('SCHEDULE.MSG.OVERLAP_MESSAGE', {
          type: info.jsonObject.identifier,
          startDate: this.datePipe.transform(
            this.timeConversionService.ConvertUTCToLocalDateTime(
              info.jsonObject.startDateTime,
            ),
            'MMM d, y, h:mm:ss a',
          ),
          endDate: this.datePipe.transform(
            this.timeConversionService.ConvertUTCToLocalDateTime(
              info.jsonObject.endDateTime,
            ),
            'MMM d, y, h:mm:ss a',
          ),
        })
        .subscribe((translation) => {
          this.toastMessageService.showWarning(translation);
        });
    }
  }

  ChangeMembership(event: any) {
    const updateRequest: UpdateAppointmentMembership =
      {} as UpdateAppointmentMembership;
    const updateClientMembership: UpdateMembership = {} as UpdateMembership;
    updateClientMembership.client_id = this.SelectedClientFormControl.value;
    updateClientMembership.subscription_id = event.value.subscription_id;
    updateClientMembership.membership_id = event.value.id;
    updateRequest.clients_with_membership = updateClientMembership;
    this.appointmentService
      .UpdateClientmembership(
        this.tenantId(),
        this.appointmentCreateResponse.create_response.id,
        updateRequest,
      )
      .subscribe({
        next: async (data: AppointmentBookingResponse) => {
          this.appointmentCreateResponse = data;
          if (
            data.client_booked_details &&
            data.client_booked_details[0].memberships
          ) {
            this.clientMemberships = data.client_booked_details[0].memberships;
            this.selectedMembership =
              data.client_booked_details[0].memberships.find(
                (m) => m.is_selected == true,
              )!;
            this.chooseSubscriptionModal = true;
          }
          this.translate
            .get('SCHEDULE.MSG.UPDATE_MEMBERSHIP_MSG')
            .subscribe((translation) => {
              this.toastMessageService.showSuccess(translation);
            });
          await this.timeout(1000);
          this.chooseSubscriptionModal = false;
          this.reloadData.emit(true);
          this.hideBookAppointment.emit(false);
          this.cd.detectChanges();
        },
        error: (error: AppErrors) => {
          this.ShowToastErrors(error);
          this.cd.detectChanges();
        },
      });
  }

  ShowToastErrors(error: AppErrors) {
    //this.toastMessageService.showError(error, 3000, 'bookappointment');
    if (error.originalError.error.length > 0) {
      error.originalError.error.forEach((e: any) => {
        if (e.errorCode.toLowerCase() == 'overlap') {
          this.translate
            .get('SCHEDULE.MSG.OVERLAP_MESSAGE', {
              type: e.jsonObject.identifier,
              startDate: this.datePipe.transform(
                this.timeConversionService.ConvertUTCToLocalDateTime(
                  e.jsonObject.startDateTime,
                ),
                'MMM d, y, h:mm:ss a',
              ),
              endDate: this.datePipe.transform(
                this.timeConversionService.ConvertUTCToLocalDateTime(
                  e.jsonObject.endDateTime,
                ),
                'MMM d, y, h:mm:ss a',
              ),
            })
            .subscribe((translation) => {
              this.toastMessageService.showErrorMessage(translation, 5000);
            });
        } else {
          this.toastMessageService.showError(error, 3000, 'bookappointment');
        }
      });
    } else {
      this.toastMessageService.showError(error, 3000, 'bookappointment');
    }
  }

  handleError(error: any) {
    if (error.originalError.error.length > 0) {
      error.originalError.error.forEach((e: any) => {
        if (e.errorCode.toLowerCase() == 'overlap') {
          this.translate
            .get('SCHEDULE.MSG.OVERLAP_MESSAGE', {
              type: e.jsonObject.identifier,
              startDate: this.datePipe.transform(
                this.timeConversionService.ConvertUTCToLocalDateTime(
                  e.jsonObject.startDateTime,
                ),
                'MMM d, y, h:mm:ss a',
              ),
              endDate: this.datePipe.transform(
                this.timeConversionService.ConvertUTCToLocalDateTime(
                  e.jsonObject.endDateTime,
                ),
                'MMM d, y, h:mm:ss a',
              ),
            })
            .subscribe((translation) => {
              this.toastMessageService.showErrorMessage(translation, 5000);
            });
        } else {
          this.toastMessageService.showError(error, 3000, 'bookappointment');
        }
      });
    } else {
      this.toastMessageService.showError(error, 3000, 'bookappointment');
    }
  }

  timeout(ms: any) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  HideErrorPopup(event: any) {
    this.showErrorPopup$?.next(false);
    this.errorMessages = [];
  }

  GoToAppointment() {
    this.router.navigate([
      '/admin/appointment-categories/create-appointment-category',
    ]);
  }

  checkStaffAvailability() {
    if (
      this.SelectedApptTypeFormControl.value &&
      this.StartDateFormControl.value &&
      this.SelectedAssignedFormControl.value
    ) {
      const endDateTime: Date = new Date(this.StartDateFormControl.value);
      endDateTime.setMinutes(
        endDateTime.getMinutes() + this.selectedApptType.duration_in_minutes,
      );
      if (this.RRuleObject.RRule) {
        const request: CheckRecurringAvailability =
          {} as CheckRecurringAvailability;
        request.recurring_start_date =
          this.timeConversionService.ConvertLocalDateTimeToUTC(
            this.StartDateFormControl.value,
          );
        request.recurring_end_date =
          this.timeConversionService.ConvertLocalDateTimeToUTC(endDateTime);
        request.start_time = this.getTimeFromDateString(
          this.StartDateFormControl.value,
        );
        request.end_time = this.getTimeFromEndDateString(endDateTime);
        request.recurring_rule = this.RRuleObject.RRule;
        this.staffAvailabilityService
          .checkStaffAvailabilityForrecurringAppointment(
            this.tenantId(),
            this.SelectedAssignedFormControl.value.id,
            this.SelectedApptTypeFormControl.value.id,
            request,
          )
          .subscribe({
            next: async (response: StaffAvailableResponse) => {
              this.isStaffAvailable = response.result;
              this.cd.detectChanges();
            },
            error: () => {
              this.disableSaveBtn = false;
              this.isStaffAvailable = true;
              this.cd.detectChanges();
            },
          });
      } else {
        this.staffAppointmentAvailability.set('start_date', {
          name: 'start_date',
          value: this.timeConversionService.ConvertLocalDateTimeToUTC(
            this.StartDateFormControl.value,
          ),
        });
        this.staffAppointmentAvailability.set('end_date', {
          name: 'end_date',
          value:
            this.timeConversionService.ConvertLocalDateTimeToUTC(endDateTime),
        });
        this.staffAvailabilityService
          .checkStaffAvailabilityForAppointment(
            this.tenantId(),
            this.SelectedAssignedFormControl.value.id,
            this.SelectedApptTypeFormControl.value.id,
            [...this.staffAppointmentAvailability.values()],
          )
          .subscribe({
            next: async (response: StaffAvailableResponse) => {
              this.isStaffAvailable = response.result;
              this.cd.detectChanges();
            },
            error: () => {
              this.disableSaveBtn = false;
              this.isStaffAvailable = true;
              this.cd.detectChanges();
            },
          });
      }
    }
  }

  getTimeFromDateString(dateString: any) {
    if (dateString == '') return `00:00:00`;
    const date =
      this.timeConversionService.ConvertLocalDateTimeToUTCInDateObject(
        dateString,
      );
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const formattedTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:00`;
    return formattedTime;
  }

  getTimeFromEndDateString(dateString: any) {
    if (dateString == '') return `00:00:00`;
    const date =
      this.timeConversionService.ConvertLocalDateTimeToUTCInDateObject(
        dateString,
      );
    const hours = date.getHours();
    const minutes = date.getMinutes();
    date.setSeconds(-1);
    const formattedTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:00`;
    return formattedTime;
  }

  ClosePopup() {
    if (!this.disableSaveBtn) {
      this.hideBookAppointment.emit(true);
      this.CreateAppointmentForm.reset();
      this.hideBookAppointment.emit(this.showBookAppointment());
    }
  }

  createProspect(event: any) {
    this.showCreateProspectPopup$.next(true);
  }

  hidePopup(clientId: number) {
    this.showCreateProspectPopup$.next(false);
  }

  get SelectedApptTypeFormControl(): UntypedFormControl {
    return this.CreateAppointmentForm.controls
      .selectedApptType as UntypedFormControl;
  }

  get SelectedApptSubTypeFormControl(): UntypedFormControl {
    return this.CreateAppointmentForm.controls
      .selectedApptSubType as UntypedFormControl;
  }

  get SelectedAssignedFormControl(): UntypedFormControl {
    return this.CreateAppointmentForm.controls
      .selectedTrainer as UntypedFormControl;
  }

  get GetSelectedRoom(): any {
    return this.CreateAppointmentForm.controls.selectedRoom.value;
  }

  get StartDateFormControl(): UntypedFormControl {
    return this.CreateAppointmentForm.controls.startDate as UntypedFormControl;
  }

  get SelectedRoomFormControl(): UntypedFormControl {
    return this.CreateAppointmentForm.controls
      .selectedRoom as UntypedFormControl;
  }

  get VirtualUrlFormControl(): UntypedFormControl {
    return this.CreateAppointmentForm.controls.virtualUrl as UntypedFormControl;
  }

  get SelectedClientFormControl(): UntypedFormControl {
    return this.CreateAppointmentForm.controls.client_id as UntypedFormControl;
  }

  get OStaffStatus(): Ienum<StaffStatus>[] {
    return Object.entries(StaffStatus)
      .filter((key) => typeof key[1] != 'number')
      .map(([key, value]) => ({ key, value }));
  }

  // get GetAcceptsTrialFormControl(): UntypedFormControl {
  //   return this.CreateAppointmentForm.controls.accepts_trial as UntypedFormControl;
  // }
}
